import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ShareIcon from "@mui/icons-material/Share";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

export const BottomActionBar = ({
  onShare,
  onContinueShopping,
  onDownload,
  onMore,
  isShareMode,
  onShareCancel,
  onShareDone,
  selectedCount,
}: {
  onShare: () => void;
  onContinueShopping: () => void;
  onDownload: () => void;
  onMore: () => void;
  isShareMode?: boolean;
  onShareCancel?: () => void;
  onShareDone?: () => void;
  selectedCount?: number;
}) => {
  if (isShareMode) {
    return (
      <div style={shareModeBarStyles.container}>
        <button style={shareModeBarStyles.cancelButton} onClick={onShareCancel}>
          Cancel
        </button>
        <span style={shareModeBarStyles.selectionText}>
          {selectedCount || 0} selected
        </span>
        <button style={shareModeBarStyles.doneButton} onClick={onShareDone}>
          Done
        </button>
      </div>
    );
  }

  return (
    <div style={bottomActionBarStyles.container}>
      <button style={bottomActionBarStyles.actionItem} onClick={onShare}>
        <ShareIcon style={bottomActionBarStyles.actionIcon} />
        <span style={bottomActionBarStyles.actionLabel}>Share<br/>Photos</span>
      </button>
      <button style={bottomActionBarStyles.actionItem} onClick={onContinueShopping}>
        <ShoppingCartIcon style={bottomActionBarStyles.actionIcon} />
        <span style={bottomActionBarStyles.actionLabel}>Continue Shopping</span>
      </button>
      <button style={bottomActionBarStyles.actionItem} onClick={onDownload}>
        <FileDownloadIcon style={bottomActionBarStyles.actionIcon} />
        <span style={bottomActionBarStyles.actionLabel}>Download<br/>All</span>
      </button>
      <button style={bottomActionBarStyles.actionItemLast} onClick={onMore}>
        <MoreHorizIcon style={bottomActionBarStyles.actionIcon} />
        <span style={bottomActionBarStyles.actionLabel}>More<br/>Options</span>
      </button>
    </div>
  );
};

const bottomActionBarStyles = {
  container: {
    backgroundColor: "#fff",
    borderTop: "1px solid #e0e0e0",
    padding: "8px 0",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    position: "fixed" as const,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
  },
  actionItem: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    cursor: "pointer",
    padding: "4px 12px",
    border: "none",
    background: "none",
    borderRight: "1px solid #e0e0e0",
    flex: 1,
  },
  actionItemLast: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    cursor: "pointer",
    padding: "4px 12px",
    border: "none",
    background: "none",
    flex: 1,
  },
  actionIcon: {
    fontSize: "32px",
    color: "#1e88e5",
    marginBottom: "4px",
  },
  actionLabel: {
    fontSize: "12px",
    color: "#0d2137",
    textAlign: "center" as const,
    maxWidth: "80px",
  },
};

const shareModeBarStyles = {
  container: {
    backgroundColor: "#fff",
    borderTop: "1px solid #e0e0e0",
    padding: "12px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "fixed" as const,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
  },
  cancelButton: {
    backgroundColor: "#fff",
    color: "#666",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: "12px 32px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
  },
  doneButton: {
    backgroundColor: "#1e88e5",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "12px 32px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
  },
  selectionText: {
    fontSize: "14px",
    color: "#0d2137",
    fontWeight: 500,
  },
};
